import { laisPath } from '../laisRouteHelpers';
import LeadsIndex from '../laisLeads/pages/LeadsIndex.vue';

export const searchClientsRoute = {
  path: laisPath('buscar-clientes'),
  name: 'search-clients',
  component: LeadsIndex,
};

export default searchClientsRoute;
